module.exports = __webpack_public_path__ + "img/logo-mazzitech.ca40433c.svg";